import _ from "lodash"
import Util from "../util"
import Activity from "./activity"

let data = {
  all: null,
  homeDelivery: null,
  onlineEvent: null,
  standard:null,
  filtered: null,
  sortBy: 'sales_rank' // 'sales_rank', 'price_up', 'price_down'
}

const init = (all) => {
  // add additional info
  all.forEach(a => a.__minPricePerPerson = Activity.getMinPricePerPerson(a));
  // store the data
  data.all = all;


  data.standard = all.map(a => a);
  data.homeDelivery = [];
  data.onlineEvent = [];
  data.standard = all.filter(a => {
    // no home delivery items in standard catalgoue
    return !a.isHomeDelivery
  })
  /*
  data.homeDelivery = all.filter (a => {
    // only home delivery items in this catalgoue
    return a.isHomeDelivery
  })
  */
  data.onlineEvent = all.filter (a => {
    // only online event items in this catalogue
    return a.isOnlineEvent
  })
  // add additional info 
  
  // filter
  data.filtered = _sort(data.standard)
}

const getData = () => { return data }

const getFiltered = () => {
  return [...data.filtered]
}
/**
 * Returns activities similar to the one provided
 * @param {} activity_id 
 * @param {*} maxItems 
 */
const getSimilar = (activity_id, maxItems) => {
  // no catalogue? no soup for you!
  if(!data.all) {
    return []
  }

  // get the activity from the catalogue
  let activity = data.all.find(a => a._id === activity_id)

  // find similar activities
  let similar = data.all
    .map(a => {
      // get similar items according to tags
      let intersection = _.intersection(a.tags, activity.tags)
      let c = {}
      Object.assign(c, a)
      c.__matchingTagCount = intersection.length
      return c
    })
    .filter(a => {
      // we do not want the one we base the selection on
      return activity_id !== a._id
    })
    .sort((a, b) => {
      return a.__matchingTagCount > b.__matchingTagCount ? -1 : 1
    })

  // return the requested number of items (or less)
  return similar.slice(0, maxItems)
}

/**
 * Returns activities that might be suitable as upsells
 * @param {} adventure 
 * @param {*} maxItems 
 */
const getUpsells = (adventure, maxItems) => {
  // no catalogue? no fish for you!
  if(!data.all) {
    return []
  }

  // do we have 'Kulinarisches' in the cart?
  let indexOfCulinary = adventure.Activities.findIndex(a => {
    const activity = data.all.find(c => c._id === a.Activity_ID)
    if(activity) {
      return (activity.tags || []).includes('kulinarisches')
    }
    else {
      return false;
    }
  })
  let hasCulinary = indexOfCulinary > -1

  // collect upsells
  let upsells

  if(hasCulinary) {
    // return acitivities with the tag 'stadt-aktivitäten'
    upsells = (data.all || []).filter(a => {
      return a.tags.includes('stadt-aktivitäten')
    })
  }
  else {
    // return culinary upsells
    upsells = (data.all || []).filter(a => a.upsellAsFood === true)
  }

  // filter out activities already in the cart and sort by salesRank
  upsells = upsells
    .filter(u => {
      let isInCart = adventure.Activities.findIndex(a => a.Activity_ID === u._id) > -1
      return !isInCart
    })
    .sort((a, b) => {
      return (a.salesRank || 99999) > (b.salesRank || 99999) ? 1 : -1
    })

  // return the requested number of items (or less)
  return upsells.slice(0, maxItems)
}

const filter = ({regions, genders, categories, text, priceRange, kinds, tags}) => {
  if(_.isNil(data.standard)) {
    return null
  }

  let filtered = data.standard
    .filter(a => {
      // price range
      let min = priceRange.min
      let max = priceRange.max < 200 ? priceRange.max : 9999999
      return a.prices[0] >= min && a.prices[0] <= max
    })
    .filter(a => {
      // region
      if (regions.items.length > 0 && regions.allSelected === false) {
        let intersection = _.intersection(a.regions, regions.items)
        return intersection.length > 0
      }
      else {
        return true
      }
    })
    .filter(a => {
      // category
      if(categories.items.length > 0 && categories.allSelected === false) {
        let intersection = _.intersection(a.tags, categories.items)
        return intersection.length > 0
      }
      else {
        return true
      }
    })
    .filter(a => {
      // gender
      if(genders.items.length > 0 && genders.allSelected === false) {
        let intersection = _.intersection(a.tags, genders.items)
        return intersection.length > 0
      }
      else {
        return true
      }
    })
    .filter(a => {
      // tags
      if(tags.items.length > 0) {
        let intersection = _.intersection(a.tags, tags.items);
        return intersection.length > 0;
      }
      else {
        return true;
      }
    })
    .filter(a => {
      // kind ("standard" or "homedelivery" or "onlineevent")
      if(kinds.allSelected) {
        return true;
      }
      else if(kinds.items.includes("standard")) {
        return !a.isHomeDelivery && !a.isOnlineEvent;
      }
      else if(kinds.items.includes("homedelivery")) {
        return a.isHomeDelivery;
      }
      else if(kinds.items.includes("onlineevent")) {
        return a.isOnlineEvent
      }
      else {
        return true;
      }
    })
    .filter(a => {
      // text
      if(text.trim().length === 0) 
        return true

      // support multiple terms seperated by comma and/or space 
      let texts = text.trim().toLowerCase()
        .split(/[, ]/) 
        .filter(s => s.trim().length > 0)
        .map(s => Util.TextSearch.simplifyString(s))
      
      // find matches
      return texts.some(t => {
        return Util.TextSearch.simplifyString(a.title).indexOf(t) !== -1 || Util.TextSearch.simplifyString(a.shortDescription).indexOf(t) !== -1
        //return a.title.toLowerCase().indexOf(t) !== -1 || a.shortDescription.toLowerCase().indexOf(t) !== -1
      })
    })

  // sort it
  let sorted = _sort(filtered);

  // we replace the data to ensure react fires state changes
  data = {
    all:data.all,
    standard:data.standard,
    homeDelivery:data.homeDelivery,
    filtered:sorted,
    sortBy:data.sortBy
  }
  // and return it
  return data
}

const sort = (sortBy) => {
  data.sortBy = sortBy

  let sorted = data.filtered
    .sort((a, b) => {
      let result = 0
      switch(data.sortBy) {
        case "sales_rank":
          result = _sortSalesRank(a, b)
          break
        case "price_up":
          result = _sortPrice(a, b, 'asc')
          break
        case "price_down":
        default:
          result = _sortPrice(a, b, 'desc')
          break
      }
      return result
    })

  // update the data
  data = {
    all:data.all,
    standard:data.standard,
    homeDelivery:data.homeDelivery,
    filtered:sorted,
    sortBy:sortBy
  }

  // return the data
  return data
}

const _sort = (filtered) => {
  return filtered
    .sort((a, b) => {
      let result = 0
      switch(data.sortBy) {
        case "sales_rank":
          result = _sortSalesRank(a, b)
          break
        case "price_up":
          result = _sortPrice(a, b, 'asc')
          break
        case "price_down":
        default:
          result = _sortPrice(a, b, 'desc')
          break
      }
      return result
    })
}

// sort functions
const _sortPrice = (a, b, direction) => {
  if (a.prices[0] === b.prices[0]) {
    return _sortName(a, b)
  }
  else {
    return direction === 'asc' ?
      a.prices[0] - b.prices[0] :
      b.prices[0] - a.prices[0]
  }
}

const _sortName = (a, b, direction) => {
  let r = 0
  if (a.title.toLowerCase() > b.title.toLowerCase()) {
    r = 1
  }
  else if (a.title.toLowerCase() < b.title.toLowerCase()) {
    r = -1
  }
  r = direction === 'asc' ? r : -1 * r
  return r
}

const _sortSalesRank = (a, b) => {
  // when sorting by sales rank, we want new activities ('isFresh' flag) to take precedence
  let sort = a.salesRank - b.salesRank
  if(a.isFresh || b.isFresh) {
    if(a.isFresh && b.isFresh) {
      return sort
    }
    else {
      return a.isFresh ? -1 : 1
    }
  }
  else {
    return sort
  }
}

const getActivityById = (id) => {
  let activity = data.all.find(a => a._id === id)
  return activity || null
}

const getActivityBySlug = (slug) => {
  // find the activity
  let activity = data.all.find(a => a.slug === slug )
  // sort images, making the default image the first one
  if(activity) {
    if(!activity.images) {
      activity.images = []
    }
    activity.images = activity.images.sort((a, b) => a.default ? -1 : 1)
  }
  // return the activity
  return activity || null
}

const getRandomActivities = (count) => {
  return _.sampleSize(data.all, count);
}

export default {
  init,

  getActivityById,
  getActivityBySlug,
  getData, 
  getSimilar,
  getUpsells,
  getFiltered,
  getRandomActivities,

  filter,
  sort
}